import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
	return new URLSearchParams(useLocation().search)
}

function OrderConfirm({ classes }) {
	const navigate = useNavigate()
	const params = useQuery().get('p')
	const dispatch = useDispatch()
	const [response, setResponse] = useState({
		isLoaded: false,
		error: false,
		message: '',
		paymentMethod: null,
		totalToPay: 0,
	})

	useEffect(() => {
		const verify = () => {
			dispatch({ type: 'startLoad@ui' })
			const instance = axios.create()
			instance.get(`${window.__endpoint}/api/order/userConfirmation?p=${params}`)
				.then((response) => {
					dispatch({ type: 'stopLoad@ui' })
					setResponse({
						error: false,
						message: response.data.message,
						paymentMethod: response.data.data.payment_method,
						totalToPay: response.data.data.total_to_pay,
						isLoaded: true,
					})
				})
				.catch(error => {
					dispatch({ type: 'stopLoad@ui' })
					setResponse({
						error: true,
						message: error.response ? error.response.data.message : '',
						isLoaded: true,
					})
				})
		}

		verify()
	}, [])

	return (<div className={classes.page}>
		{response.isLoaded && <React.Fragment>
			<h2 className={classes.pageTitle}>{response.error ? 'Errore nella conferma dell\'ordine' : 'Ordine confermato'}</h2>
			<center>
				{response.error && <p>Si è verificato un problema nella conferma del tuo ordine</p>}
				<div dangerouslySetInnerHTML={{
					__html: response.message
				}}></div>
				<p>
					{response.error && <Button color="primary" variant="contained" onClick={() => navigate('/')}>Prosegui gli acquisti</Button>}
					{!response.error && response.paymentMethod.online_flag == 1 && <Button color="primary" variant="contained" onClick={() => navigate(`/order/payment?p=${params}`)}>Procedi al pagamento</Button>}
				</p>
			</center>
		</React.Fragment>}
	</div>)
}

export default withStyles(style)(OrderConfirm)
